// 업종별 UI 용어 맵핑 + 모드 감지
// ─────────────────────────────────────────────────
// 새 모드 추가 시: INDUSTRY_TERMS에 항목 추가 → MODES 배열에 등록 → INDUSTRY_MODE_MAP에 업종명 등록

export const INDUSTRY_TERMS = {
  // ── 식음료 ──────────────────────────────────────
  food: {
    recipe:           '레시피',
    recipeItem:       '메뉴',
    category:         '카테고리',
    ingredient:       '식재료',
    servingLabel:     '인분',
    servingUnit:      'g',
    servingBaseLabel: '기준량 (g)',
    totalOutputLabel: '총 생산량 (g)',
    qtyUnit:          'g',
    orderTab:         '단체주문',
    orderInputLabel:  '인분 수',
    orderRowLabel:    (name, v) => `${name} ${v}인분`,
    typeLabels:       { semi: '반제품', menu: '메뉴' },
    typeOptions:      [{ value: 'semi', label: '반제품' }, { value: 'menu', label: '판매 메뉴' }],
    lossRateEnabled:  false,
    sidebarNewLabel:  '새 레시피',
    editorNewTitle:   '새 레시피 추가',
    editorEditTitle:  '레시피 편집',
    editorNamePlaceholder: '예: 떡볶이 소스',
    editorIngredientPlaceholder: '재료명 입력 (단가표 자동검색)',
    emptySlateIcon:   '📋',
    emptySlateText:   '왼쪽에서 레시피를 선택하세요',
    costCardLabel:    (servings) => `${servings}인분 원가`,
    costCardSub:      '1인분 원가',
    servingBaseValue: (item) => `${item.serving_g}g`,
    totalOutputValue: (item) => `${item.total_output}g`,
    calcRatio:        (recipe, value) =>
      recipe.serving_g > 0
        ? (recipe.serving_g * value) / recipe.total_output
        : value,
  },

  // ── 인테리어 ────────────────────────────────────
  interior: {
    recipe:           '자재 목록',
    recipeItem:       '시공 항목',
    category:         '시공 분류',
    ingredient:       '자재',
    servingLabel:     '면적',
    servingUnit:      'm²',
    servingBaseLabel: '기준 면적 (m²)',
    totalOutputLabel: '기준 면적 (m²)',
    qtyUnit:          '',            // 재료별 unit 필드 사용
    orderTab:         '면적 계산',
    orderInputLabel:  '시공 면적 (m²)',
    orderRowLabel:    (name, v) => `${name} ${v}m²`,
    typeLabels:       { semi: '부자재', menu: '시공 항목' },
    typeOptions:      [{ value: 'semi', label: '부자재' }, { value: 'menu', label: '시공 항목' }],
    lossRateEnabled:  true,
    sidebarNewLabel:  '새 시공 항목',
    editorNewTitle:   '새 시공 항목 추가',
    editorEditTitle:  '시공 항목 편집',
    editorNamePlaceholder: '예: 합지 도배 (10m²)',
    editorIngredientPlaceholder: '자재명 입력 (단가표 자동검색)',
    emptySlateIcon:   '🔨',
    emptySlateText:   '왼쪽에서 시공 항목을 선택하세요',
    costCardLabel:    (area) => `${area}m² 자재비`,
    costCardSub:      '1m² 자재비',
    servingBaseValue: (item) => `${item.serving_g}m²`,
    totalOutputValue: (item) => `${item.total_output}m²`,
    calcRatio:        (recipe, value) =>
      recipe.serving_g > 0 ? value / recipe.serving_g : value,
  },

  // ── 미용실 ──────────────────────────────────────
  beauty: {
    recipe:           '시술 목록',
    recipeItem:       '시술 항목',
    category:         '시술 분류',
    ingredient:       '재료/소모품',
    servingLabel:     '횟수',
    servingUnit:      'g',
    servingBaseLabel: '기준량 (g)',
    totalOutputLabel: '총 사용량 (g)',
    qtyUnit:          'g',
    orderTab:         '예약 계산',
    orderInputLabel:  '시술 횟수',
    orderRowLabel:    (name, v) => `${name} ${v}회`,
    typeLabels:       { semi: '베이스 시술', menu: '시술 메뉴' },
    typeOptions:      [{ value: 'semi', label: '베이스 시술' }, { value: 'menu', label: '시술 메뉴' }],
    lossRateEnabled:  false,
    sidebarNewLabel:  '새 시술 추가',
    editorNewTitle:   '새 시술 추가',
    editorEditTitle:  '시술 편집',
    editorNamePlaceholder: '예: 염색 (단발)',
    editorIngredientPlaceholder: '재료명 입력 (단가표 자동검색)',
    emptySlateIcon:   '✂️',
    emptySlateText:   '왼쪽에서 시술을 선택하세요',
    costCardLabel:    (n) => `${n}회 원가`,
    costCardSub:      '1회 원가',
    servingBaseValue: (item) => `${item.serving_g}g`,
    totalOutputValue: (item) => `${item.total_output}g`,
    calcRatio:        (recipe, value) =>
      recipe.serving_g > 0
        ? (recipe.serving_g * value) / recipe.total_output
        : value,
  },

  // ── 카센터 ──────────────────────────────────────
  auto: {
    recipe:           '정비 목록',
    recipeItem:       '정비 항목',
    category:         '정비 분류',
    ingredient:       '부품/소모품',
    servingLabel:     '대수',
    servingUnit:      '대',
    servingBaseLabel: '기준 대수',
    totalOutputLabel: '총 기준 대수',
    qtyUnit:          '개',
    orderTab:         '차량 계산',
    orderInputLabel:  '차량 대수',
    orderRowLabel:    (name, v) => `${name} ${v}대`,
    typeLabels:       { semi: '기본 작업', menu: '정비 메뉴' },
    typeOptions:      [{ value: 'semi', label: '기본 작업' }, { value: 'menu', label: '정비 메뉴' }],
    lossRateEnabled:  false,
    sidebarNewLabel:  '새 정비 항목',
    editorNewTitle:   '새 정비 항목 추가',
    editorEditTitle:  '정비 항목 편집',
    editorNamePlaceholder: '예: 엔진오일 교환',
    editorIngredientPlaceholder: '부품명 입력 (단가표 자동검색)',
    emptySlateIcon:   '🔧',
    emptySlateText:   '왼쪽에서 정비 항목을 선택하세요',
    costCardLabel:    (n) => `${n}대 원가`,
    costCardSub:      '1대 원가',
    servingBaseValue: (item) => `${item.serving_g}대`,
    totalOutputValue: (item) => `${item.total_output}대`,
    calcRatio:        (recipe, value) =>
      recipe.serving_g > 0
        ? (recipe.serving_g * value) / recipe.total_output
        : value,
  },

  // ── 세탁소 ──────────────────────────────────────
  laundry: {
    recipe:           '세탁 메뉴',
    recipeItem:       '세탁 항목',
    category:         '세탁 분류',
    ingredient:       '세제/소모품',
    servingLabel:     '건수',
    servingUnit:      '건',
    servingBaseLabel: '기준 건수',
    totalOutputLabel: '총 기준 건수',
    qtyUnit:          'g',
    orderTab:         '주문 계산',
    orderInputLabel:  '세탁 건수',
    orderRowLabel:    (name, v) => `${name} ${v}건`,
    typeLabels:       { semi: '기본 처리', menu: '세탁 메뉴' },
    typeOptions:      [{ value: 'semi', label: '기본 처리' }, { value: 'menu', label: '세탁 메뉴' }],
    lossRateEnabled:  false,
    sidebarNewLabel:  '새 세탁 항목',
    editorNewTitle:   '새 세탁 항목 추가',
    editorEditTitle:  '세탁 항목 편집',
    editorNamePlaceholder: '예: 와이셔츠 세탁',
    editorIngredientPlaceholder: '세제명 입력 (단가표 자동검색)',
    emptySlateIcon:   '👕',
    emptySlateText:   '왼쪽에서 세탁 항목을 선택하세요',
    costCardLabel:    (n) => `${n}건 원가`,
    costCardSub:      '1건 원가',
    servingBaseValue: (item) => `${item.serving_g}건`,
    totalOutputValue: (item) => `${item.total_output}건`,
    calcRatio:        (recipe, value) =>
      recipe.serving_g > 0
        ? (recipe.serving_g * value) / recipe.total_output
        : value,
  },
};

// 전체 모드 목록 (헤더 모드 선택기에서 사용)
// V30: 셈핏은 식음료 단일 앱으로 집중. 다른 업종 모드는 INDUSTRY_TERMS 매핑은 유지하되 UI에서 숨김.
export const MODES = [
  { id: 'food',     label: '식음료',   icon: '🍱' },
];

// 업종명 → 모드 맵핑 (가입 시 자동 적용)
const INDUSTRY_MODE_MAP = {
  // 건설 · 인테리어
  '인테리어':               'interior',
  '실내 인테리어 · 도배':   'interior',
  '리모델링 · 시공':        'interior',
  '가구 · 가구제작':        'interior',
  '조명 · 전기공사':        'interior',
  '바닥재 · 마루':          'interior',
  '기타 인테리어':          'interior',

  // 미용 · 뷰티
  '미용실':                 'beauty',
  '헤어샵 · 미용실':        'beauty',
  '피부관리실 · 에스테틱':  'beauty',
  '네일샵':                 'beauty',
  '속눈썹 · 반영구':        'beauty',
  '왁싱샵':                 'beauty',
  '기타 미용업':            'beauty',

  // 자동차 · 정비
  '카센터':                 'auto',
  '카센터 · 종합정비':      'auto',
  '타이어 · 휠 전문점':     'auto',
  '자동차 부품 판매':       'auto',
  '세차 · 디테일링':        'auto',
  '튜닝 · 용품점':          'auto',
  '기타 자동차업':          'auto',

  // 세탁 · 생활서비스
  '세탁소':                 'laundry',
  '세탁소 · 드라이클리닝':  'laundry',
  '코인세탁 · 빨래방':      'laundry',
  '기타 세탁업':            'laundry',
  // 나머지(외식업·기타)는 기본값 food
};

export function getIndustryMode(industry) {
  return INDUSTRY_MODE_MAP[industry] || 'food';
}

// 모드 ID → 용어 객체
export function getTermsFromMode(modeId) {
  return INDUSTRY_TERMS[modeId] || INDUSTRY_TERMS.food;
}

// 업종명 → 용어 객체 (하위 호환)
export function getTerms(industry) {
  return getTermsFromMode(getIndustryMode(industry));
}
